@if (spec$ | async; as spec) {
  <!-- component is expected to be inside a pane -->
  <elder-pane-content class="full p-0">
    <!-- p-0 for nested panes -->
    <elder-pane-subtitle>{{ 'context.details' | translate }}</elder-pane-subtitle>
    <div class="layout-row gap-md place-start-center">
      <mat-form-field>
        <mat-label>{{ 'context.name' | translate }}</mat-label>
        <input
          matInput
          name="name"
          type="text"
          required
          placeholder="{{ 'context.name' | translate }}"
          [(ngModel)]="spec.name"
          #idModel="ngModel"
        />
        <mat-error elderValidationError></mat-error>
      </mat-form-field>
    </div>
    <mat-tab-group class="flex" animationDuration="0ms">
      <!-- Tab conditions -->
      <mat-tab>
        <ng-template mat-tab-label>
          <span
            class="noselect"
            [matBadge]="spec?.conditions?.length?.toString()"
            [matBadgeHidden]="!spec?.conditions?.length"
            [matBadgeOverlap]="false"
            >{{ 'skillSets.conditions.title' | translate }}
          </span>
        </ng-template>
        <elder-basic-pane-layout class="full p-0">
          <elder-pane>
            <app-constraint-spec-table
              class="flex"
              [constraints]="spec.conditions"
              (constraintsChange)="onConditionChanged($event)"
            >
            </app-constraint-spec-table>
          </elder-pane>
        </elder-basic-pane-layout>
      </mat-tab>
      <!-- Tab dynamic property specs -->
      <mat-tab>
        <elder-basic-pane-layout class="full p-0">
          <elder-pane class="outlined">
            <ng-template mat-tab-label>
              <span
                class="noselect"
                [matBadge]="spec?.properties?.length?.toString()"
                [matBadgeHidden]="!spec?.properties?.length"
                [matBadgeOverlap]="false"
                >{{ 'properties.title' | translate }}
              </span>
            </ng-template>
            <app-property-spec-table
              class="flex"
              [propertyKinds]="propertyKinds"
              [specs]="spec.properties"
              (specsChange)="onPropertiesChanged($event)"
            >
            </app-property-spec-table>
          </elder-pane>
        </elder-basic-pane-layout>
      </mat-tab>
    </mat-tab-group>
  </elder-pane-content>
}
